import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logger, stats } from '@fiverr-private/obs';
import { STATS_METRIC_PREFIX } from '../ContactSellerModal/constants';
import { FETCH_INITIAL_DATA_HOURLY_FAILURE, FETCH_INITIAL_DATA_HOURLY_SUCCESS } from '../ContactSellerModal/metrics';

export const fetchHourlyRate = async(recipientName) => {
    try {
        const url = pathfinder('get_hourly_rate_by_username', { username: recipientName });
        const { data } = await axios.get(url);

        countSuccess();

        return data;
    } catch (error) {
        countFailure();
        logError(error, recipientName);
        return null;
    }
};

const logError = (error, recipientName) => {
    logger.error(error, {
        details: 'Failed to fetch hourly rate',
        recipientName
    });
};

const countFailure = () => {
    stats.count(STATS_METRIC_PREFIX, FETCH_INITIAL_DATA_HOURLY_FAILURE);
};

const countSuccess = () => {
    stats.count(STATS_METRIC_PREFIX, FETCH_INITIAL_DATA_HOURLY_SUCCESS);
};
